<template lang="pug">
#modal-visualizacao-laudo
    el-dialog(
        :visible='show',
        width='45%',
        :close-on-click-modal='false',
        :before-close='cancelarCadastro',
        :show-close='true'
    )
        template(slot='title')
            span.atention-icon !
            span.header-text {{ $t('laudos.renovabio.identificacaoDeLaudoGerado') }}
        .cabecalho
        p(v-if='isLote || isTerritorio') {{ $t('laudos.renovabio.encontramosLaudosGeradosUltimosTrintaDias', { quantidadeCars }) }}
        p(v-else) {{ validaCar() }}
        span.alinhamento-botoes(slot='footer', v-if='isLote || isTerritorio')
            BaseButton(@click='cancelarCadastro') {{ $t('mensagens.comuns.cancelar') }}
            span
                BaseButton.button-outline(@click='processarNovosCARs') {{ $t('laudos.renovabio.processarCarsNovos') }}
                BaseButton.button-outline(@click='processarTodosCARs') {{ $t('laudos.renovabio.processarTodosCars') }}
        span.alinhamento-botoes(slot='footer', v-else)
            BaseButton(@click='cancelarCadastro') {{ $t('mensagens.comuns.cancelar') }}
            BaseButton(@click='processarNovosCARs', type='primary') {{ $t('laudos.renovabio.solicitarNovoLaudo') }}
</template>

<script>
import LaudosService from '@/modules/laudos/services/LaudosService';
import TipoLaudo from '@/modules/laudos/constants/TipoLaudo';
import BaseButton from '@/modules/laudos/components/BaseButton.vue';

export default {
    name: 'ModalLaudosJaSolicitados',

    components: {
        BaseButton
    },

    emits: ['update:show', 'getLaudos', 'voltarRota', 'resetProps'],

    props: {
        show: {
            type: Boolean,
            required: true
        },
        quantidadeCars: {
            type: Number,
            required: true
        },
        carsNovos: {
            type: Array,
            required: false
        },
        infoLaudosParaCadastro: {
            type: Array,
            required: false
        },
        isLote: {
            type: Boolean,
            required: false
        },
        isTerritorio: {
            type: Boolean,
            required: false
        }
    },

    data() {
        return {
            radio: null,
            arquivoComResultado: null,
            isLoteData: this.isLote,
            isTerritorioData: this.isTerritorio
        };
    },

    methods: {
        validaCar() {
            let carSelecionado = this.infoLaudosParaCadastro[0]?.car?.codigo;

            return this.$t(
                'laudos.renovabio.encontramosLaudoGeradoUltimosTrintaDias',
                { carSelecionado }
            );
        },

        closeDialog() {
            this.$emit('update:show', false);
            this.$emit('resetProps');
            this.isLoteData = false;
            this.isTerritorioData = false;
        },

        processarTodosCARs() {
            if (this.isLote) {
                this.$emit('buttonClicked', 'todos');
                this.closeDialog();
                return;
            }

            this.cadastrarLaudos(this.infoLaudosParaCadastro);
            this.closeDialog();
        },

        processarNovosCARs() {
            if (this.isLote) {
                this.$emit('buttonClicked', 'novos');
                this.closeDialog();
                return;
            }

            const quantidadeNovos = this.isTerritorio
                ? this.carsNovos.length
                : this.infoLaudosParaCadastro.length;

            if (quantidadeNovos > 0) {
                if (this.isTerritorio) {
                    let novos = this.carsNovos.map(p => {
                        return {
                            ...p,
                            car: null,
                            tipoLaudoId: TipoLaudo.RENOVABIO
                        };
                    });
                    this.cadastrarLaudos(novos);
                } else {
                    this.cadastrarLaudos(this.infoLaudosParaCadastro);
                }
            } else {
                this.$notify.info({
                    message: this.$t(
                        'laudos.renovabio.naoHaNovosCarsParaProcessar'
                    )
                });
            }

            this.closeDialog();
        },

        cancelarCadastro() {
            if (this.isLote) {
                this.$emit('buttonClicked', 'cancelar');
                this.closeDialog();
                return;
            }

            this.closeDialog();
        },

        cadastrarLaudos(informacaoLaudos) {
            LaudosService.cadastrarLaudos({ informacaoLaudos })
                .then(() => {
                    this.$notify.success({
                        message: this.$t(
                            'laudos.solicitacaoRealizadaComSucesso'
                        )
                    });
                    this.closeDialog();

                    if (this.isTerritorio) {
                        this.$emit('voltarRota');
                        return;
                    }

                    this.$emit('getLaudos');
                })
                .catch(error => {
                    this.$notify.error({
                        message: error.message
                    });
                });
        }
    }
};
</script>

<style lang="scss">
#modal-visualizacao-laudo {
    .el-dialog__footer {
        margin-top: 5px;
    }

    .alinhamento-botoes {
        display: flex;
        width: 100%;
        justify-content: space-between;
    }

    .button-outline {
        border-color: var(--secondary-two) !important;
    }

    .el-dialog__header {
        background-color: rgb(223, 223, 223) !important;
        display: flex;
        align-items: center;
        padding-bottom: 14px !important;
    }

    .atention-icon {
        display: flex;
        justify-content: center;
        background-color: rgb(255, 191, 73);
        width: 20px;
        height: 20px;
        border-radius: 100px;
        color: white;
        margin-right: 10px;
        font-size: 14px;
    }

    .header-text {
        font-weight: bold;
    }
}
</style>
